import RefreshIcon from "@mui/icons-material/Refresh";
import { useState } from "react";
import { adminApi } from "../services/api";
import { useToast } from "./Toast";
import ConfirmationModal from "./ConfirmationModal";
import { parseServerDate } from "../utils/formatters";

const RefreshMetricsBtn = () => {
  const [showRefreshConfirm, setShowRefreshConfirm] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { showToast } = useToast();

  const handleRefreshMetrics = async () => {
    setShowRefreshConfirm(false);
    setIsRefreshing(true);
    try {
      const result = await adminApi.refreshMetrics();
      if (result.skipped) {
        const who = result.last_run_by_email
          ? `by ${result.last_run_by_email}`
          : "by the scheduler";
        const when = result.last_refresh_at
          ? parseServerDate(result.last_refresh_at).toLocaleString()
          : "recently";
        showToast("error", `Refresh skipped — a refresh was already run ${who} ${when === "recently" ? "recently" : `on ${when}`}. Only one global refresh is allowed per 24 hours.`);
      } else {
        const msg =
          (result.errors ?? 0) > 0
            ? `Refresh done in ${result.duration_s}s — ${result.clusters_refreshed} clusters, ${result.errors} error(s)`
            : `Refresh complete in ${result.duration_s}s — ${result.clusters_refreshed} clusters across ${result.domains_scanned} domains`;
        showToast((result.errors ?? 0) > 0 ? "warning" : "success", msg);
      }
    } catch (err) {
      showToast(
        "error",
        err instanceof Error ? err.message : "Metrics refresh failed"
      );
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <>
      <button
        className="rounded-full bg-my-orange text-white font-semibold px-6 py-3 flex items-center gap-2"
        onClick={() => setShowRefreshConfirm(true)}
        disabled={isRefreshing}
        title="Refresh keyword metrics for all tenants"
      >
        <RefreshIcon className={isRefreshing ? "animate-spin" : ""} />
        <span>{isRefreshing ? "Refreshing Metrics..." : "Refresh Metrics"}</span>
      </button>

      <ConfirmationModal
        isOpen={showRefreshConfirm}
        onClose={() => setShowRefreshConfirm(false)}
        onConfirm={handleRefreshMetrics}
        title="Refresh All Metrics"
        message={
          "This will re-fetch keyword metrics from DataForSEO for every cluster across all tenants. " +
          "It may take several minutes and will consume API credits. " +
          "Use this when the scheduled weekly refresh failed (e.g. due to network errors)."
        }
        confirmText="Refresh All"
        variant="warning"
      />
    </>
  )
}

export default RefreshMetricsBtn;